import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { FusionAuthService } from "@fusionauth/angular-sdk";
import { Observable } from "rxjs";

@Injectable()
export default class CanActivateLogged implements CanActivate {
  constructor(private fusionAuthService: FusionAuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {

    return this.fusionAuthService.isLoggedIn() || this.router.navigate(['/']);
  }
}